module.exports = __webpack_public_path__ + "img/not.81b4c5b0.png";